import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propShape } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
const PhoneNumberFields = (props) => {
    const { phone1, phone2, phone3 } = props;
    const metas = useMemo(() => [phone1.meta, phone2.meta, phone3.meta], [phone1.meta, phone2.meta, phone3.meta]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'form-flex-split is-third-nowrap-form' }, { children: [_jsx(PlainInput, { className: 'input-form-text', input: phone1.input, maxLength: 4, meta: phone1.meta, placeholder: '03', type: 'tel' }), _jsx("span", { children: "-" }), _jsx(PlainInput, { className: 'input-form-text', input: phone2.input, maxLength: 4, meta: phone2.meta, placeholder: '2345', type: 'tel' }), _jsx("span", { children: "-" }), _jsx(PlainInput, { className: 'input-form-text', input: phone3.input, maxLength: 4, meta: phone3.meta, placeholder: '6789', type: 'tel' })] })), _jsx(InputError, { metas: metas })] }));
};
PhoneNumberFields.propTypes = {
    phone1: propShape().isRequired,
    phone2: propShape().isRequired,
    phone3: propShape().isRequired,
};
export default PhoneNumberFields;
